module.exports = __webpack_public_path__ + "img/logo-minsterio-educacion-formacion-profecional-deportes-amarillo.cf0ec483.jpg";